var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","color":"transparent","absolute":""}},[_c('v-col',{staticClass:"pa-3"},[_c('v-row',{staticClass:"justify-center align-center"}),_c('v-row',{staticClass:"justify-center"},[_c('div',[_vm._v(" Suvence Technologies Limited © "+_vm._s(new Date().getFullYear())+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }